<template>
	<v-runtime-template :template="result.view"></v-runtime-template>
</template>

<script>
	import VRuntimeTemplate from "v-runtime-template";
	import * as VuetifyComponents from "vuetify/lib/components";

	export default {
		name: "ActionREM",

		props: {
			result: Object,
		},

		components: {
			VRuntimeTemplate,
			...VuetifyComponents,
		},

		computed: {
			items() {
				if (!this.result?.data) return [];
				else return this.result?.data;
			},
		},

		methods: {
			async downloadREM(pagamentoEletronico) {

                let arquivoNomeRandomico = Math.random().toString(36).substring(2, 10);
                let arquivoNomeCompleto = `${arquivoNomeRandomico}.rem`;
                let arquivoREM = pagamentoEletronico.rem;

                const url = window.URL.createObjectURL(new Blob([arquivoREM]));
                const link = document.createElement('a');

                link.href = url;
                link.setAttribute("download", arquivoNomeCompleto);
                document.body.appendChild(link);
                link.click();

				// const blob = new Blob(["\ufeff", data.rem], { type: "text/rem" });
				// const url = window.URL.createObjectURL(blob);
				// const a = document.createElement("a");
				// a.setAttribute("hidden", "");
				// a.setAttribute("href", url);
				// a.setAttribute("download", `${arquivoNome}.rem`);
				// document.body.appendChild(a);
				// a.click();
				// document.body.removeChild(a);

			},

			close() {
				this.$emit("close");
			},
		},

		created: function () {
			this.downloadREM(this.result.data);
		},

		mounted() {},
	};
</script>
